import { MediaObject } from "@/ds/custom/MediaObject";
import { CollectionImage } from "@/features/common/components/CollectionImage";
import type { FC } from "react";

export interface SmallCollectionDisplayProps {
	name: string;
	description?: string;
	image: number;
	onClick?: () => void;
	className?: string;
}

export const SmallCollectionDisplay: FC<SmallCollectionDisplayProps> = props => {
	const {
		name,
		description,
		image,
		onClick,
		className
	} = props;

	return (
		<MediaObject
			media={<CollectionImage image={image} className={className} />}
			title={name}
			description={description}
			onClick={onClick} />
	);
};
